import { render, staticRenderFns } from "./SettingsTunnel.vue?vue&type=template&id=35c83452&scoped=true"
import script from "./SettingsTunnel.vue?vue&type=script&lang=js"
export * from "./SettingsTunnel.vue?vue&type=script&lang=js"
import style0 from "./SettingsTunnel.vue?vue&type=style&index=0&id=35c83452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c83452",
  null
  
)

export default component.exports